/**
 * Validate orcid id
 *
 * @param {String} orcid
 *
 * @return {boolean}
 */
export function isOrcidValidation(orcid) {
    if (!orcid) {
        return null;
    }

    return /^[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{3}[0-9X]$/.test(orcid) ? null : 'validation.error.orcid';
}



// WEBPACK FOOTER //
// ./src/utils/isOrcidValidation.js